module.exports = __webpack_public_path__ + "static/media/warning_icon.10252fe5.svg";